export default __webpack_public_path__ + "static/media/discord.6ce30e6d.svg";